{
  "bug": {
    "name": "Bug",
    "category": "Physical",
    "effectiveness": {
      "???": 1,
      "Bug": 1,
      "Dark": 2,
      "Dragon": 1,
      "Electric": 1,
      "Fairy": 1,
      "Fighting": 1,
      "Fire": 0.5,
      "Flying": 0.5,
      "Ghost": 1,
      "Grass": 2,
      "Ground": 1,
      "Ice": 1,
      "Normal": 1,
      "Poison": 0.5,
      "Psychic": 2,
      "Rock": 1,
      "Steel": 0.5,
      "Water": 1
    }
  },
  "dark": {
    "name": "Dark",
    "category": "Special",
    "effectiveness": {
      "???": 1,
      "Bug": 1,
      "Dark": 0.5,
      "Dragon": 1,
      "Electric": 1,
      "Fairy": 0.5,
      "Fighting": 0.5,
      "Fire": 1,
      "Flying": 1,
      "Ghost": 2,
      "Grass": 1,
      "Ground": 1,
      "Ice": 1,
      "Normal": 1,
      "Poison": 1,
      "Psychic": 2,
      "Rock": 1,
      "Steel": 1,
      "Water": 1
    }
  },
  "dragon": {
    "name": "Dragon",
    "category": "Special",
    "effectiveness": {
      "???": 1,
      "Bug": 1,
      "Dark": 1,
      "Dragon": 2,
      "Electric": 1,
      "Fairy": 0,
      "Fighting": 1,
      "Fire": 1,
      "Flying": 1,
      "Ghost": 1,
      "Grass": 1,
      "Ground": 1,
      "Ice": 0.5,
      "Normal": 1,
      "Poison": 1,
      "Psychic": 1,
      "Rock": 1,
      "Steel": 0.5,
      "Water": 1
    }
  },
  "electric": {
    "name": "Electric",
    "category": "Special",
    "effectiveness": {
      "???": 1,
      "Bug": 1,
      "Dark": 1,
      "Dragon": 0.5,
      "Electric": 0.5,
      "Fairy": 1,
      "Fighting": 1,
      "Fire": 1,
      "Flying": 2,
      "Ghost": 1,
      "Grass": 0.5,
      "Ground": 0,
      "Ice": 1,
      "Normal": 1,
      "Poison": 1,
      "Psychic": 1,
      "Rock": 1,
      "Steel": 1,
      "Water": 2
    }
  },
  "fairy": {
    "name": "Fairy",
    "effectiveness": {
      "???": 1,
      "Bug": 1,
      "Dark": 2,
      "Dragon": 2,
      "Electric": 1,
      "Fairy": 1,
      "Fighting": 2,
      "Fire": 0.5,
      "Flying": 1,
      "Ghost": 1,
      "Grass": 1,
      "Ground": 1,
      "Ice": 1,
      "Normal": 1,
      "Poison": 0.5,
      "Psychic": 1,
      "Rock": 1,
      "Steel": 0.5,
      "Water": 1
    }
  },
  "fighting": {
    "name": "Fighting",
    "category": "Physical",
    "effectiveness": {
      "???": 1,
      "Bug": 0.5,
      "Dark": 2,
      "Dragon": 1,
      "Electric": 1,
      "Fairy": 0.5,
      "Fighting": 1,
      "Fire": 1,
      "Flying": 0.5,
      "Ghost": 0,
      "Grass": 1,
      "Ground": 1,
      "Ice": 2,
      "Normal": 2,
      "Poison": 0.5,
      "Psychic": 0.5,
      "Rock": 2,
      "Steel": 2,
      "Water": 1
    }
  },
  "fire": {
    "name": "Fire",
    "category": "Special",
    "effectiveness": {
      "???": 1,
      "Bug": 2,
      "Dark": 1,
      "Dragon": 0.5,
      "Electric": 1,
      "Fairy": 1,
      "Fighting": 1,
      "Fire": 0.5,
      "Flying": 1,
      "Ghost": 1,
      "Grass": 2,
      "Ground": 1,
      "Ice": 2,
      "Normal": 1,
      "Poison": 1,
      "Psychic": 1,
      "Rock": 0.5,
      "Steel": 2,
      "Water": 0.5
    }
  },
  "flying": {
    "name": "Flying",
    "category": "Physical",
    "effectiveness": {
      "???": 1,
      "Bug": 2,
      "Dark": 1,
      "Dragon": 1,
      "Electric": 0.5,
      "Fairy": 1,
      "Fighting": 2,
      "Fire": 1,
      "Flying": 1,
      "Ghost": 1,
      "Grass": 2,
      "Ground": 1,
      "Ice": 0.5,
      "Normal": 1,
      "Poison": 1,
      "Psychic": 1,
      "Rock": 0.5,
      "Steel": 0.5,
      "Water": 1
    }
  },
  "ghost": {
    "name": "Ghost",
    "category": "Physical",
    "effectiveness": {
      "???": 1,
      "Bug": 1,
      "Dark": 0.5,
      "Dragon": 1,
      "Electric": 1,
      "Fairy": 1,
      "Fighting": 1,
      "Fire": 1,
      "Flying": 1,
      "Ghost": 2,
      "Grass": 1,
      "Ground": 1,
      "Ice": 1,
      "Normal": 0,
      "Poison": 1,
      "Psychic": 2,
      "Rock": 1,
      "Steel": 1,
      "Water": 1
    }
  },
  "grass": {
    "name": "Grass",
    "category": "Special",
    "effectiveness": {
      "???": 1,
      "Bug": 0.5,
      "Dark": 1,
      "Dragon": 0.5,
      "Electric": 1,
      "Fairy": 1,
      "Fighting": 1,
      "Fire": 0.5,
      "Flying": 0.5,
      "Ghost": 1,
      "Grass": 0.5,
      "Ground": 2,
      "Ice": 1,
      "Normal": 1,
      "Poison": 0.5,
      "Psychic": 1,
      "Rock": 2,
      "Steel": 0.5,
      "Water": 2
    }
  },
  "ground": {
    "name": "Ground",
    "category": "Physical",
    "effectiveness": {
      "???": 1,
      "Bug": 0.5,
      "Dark": 1,
      "Dragon": 1,
      "Electric": 2,
      "Fairy": 1,
      "Fighting": 1,
      "Fire": 2,
      "Flying": 0,
      "Ghost": 1,
      "Grass": 0.5,
      "Ground": 1,
      "Ice": 0.5,
      "Normal": 1,
      "Poison": 2,
      "Psychic": 1,
      "Rock": 2,
      "Steel": 2,
      "Water": 1
    }
  },
  "ice": {
    "name": "Ice",
    "category": "Special",
    "effectiveness": {
      "???": 1,
      "Bug": 1,
      "Dark": 1,
      "Dragon": 2,
      "Electric": 1,
      "Fairy": 1,
      "Fighting": 1,
      "Fire": 0.5,
      "Flying": 2,
      "Ghost": 1,
      "Grass": 2,
      "Ground": 2,
      "Ice": 0.5,
      "Normal": 1,
      "Poison": 1,
      "Psychic": 1,
      "Rock": 1,
      "Steel": 0.5,
      "Water": 0.5
    }
  },
  "normal": {
    "name": "Normal",
    "category": "Physical",
    "effectiveness": {
      "???": 1,
      "Bug": 1,
      "Dark": 1,
      "Dragon": 1,
      "Electric": 1,
      "Fairy": 1,
      "Fighting": 1,
      "Fire": 1,
      "Flying": 1,
      "Ghost": 0,
      "Grass": 1,
      "Ground": 1,
      "Ice": 1,
      "Normal": 1,
      "Poison": 1,
      "Psychic": 1,
      "Rock": 0.5,
      "Steel": 0.5,
      "Water": 1
    }
  },
  "poison": {
    "name": "Poison",
    "category": "Physical",
    "effectiveness": {
      "???": 1,
      "Bug": 1,
      "Dark": 1,
      "Dragon": 1,
      "Electric": 1,
      "Fairy": 2,
      "Fighting": 1,
      "Fire": 1,
      "Flying": 1,
      "Ghost": 0.5,
      "Grass": 2,
      "Ground": 0.5,
      "Ice": 1,
      "Normal": 1,
      "Poison": 0.5,
      "Psychic": 1,
      "Rock": 0.5,
      "Steel": 0,
      "Water": 1
    }
  },
  "psychic": {
    "name": "Psychic",
    "category": "Special",
    "effectiveness": {
      "???": 1,
      "Bug": 1,
      "Dark": 0,
      "Dragon": 1,
      "Electric": 1,
      "Fairy": 1,
      "Fighting": 2,
      "Fire": 1,
      "Flying": 1,
      "Ghost": 1,
      "Grass": 1,
      "Ground": 1,
      "Ice": 1,
      "Normal": 1,
      "Poison": 2,
      "Psychic": 0.5,
      "Rock": 1,
      "Steel": 0.5,
      "Water": 1
    }
  },
  "rock": {
    "name": "Rock",
    "category": "Physical",
    "effectiveness": {
      "???": 1,
      "Bug": 2,
      "Dark": 1,
      "Dragon": 1,
      "Electric": 1,
      "Fairy": 1,
      "Fighting": 0.5,
      "Fire": 2,
      "Flying": 2,
      "Ghost": 1,
      "Grass": 1,
      "Ground": 0.5,
      "Ice": 2,
      "Normal": 1,
      "Poison": 1,
      "Psychic": 1,
      "Rock": 1,
      "Steel": 0.5,
      "Water": 1
    }
  },
  "steel": {
    "name": "Steel",
    "category": "Physical",
    "effectiveness": {
      "???": 1,
      "Bug": 1,
      "Dark": 1,
      "Dragon": 1,
      "Electric": 0.5,
      "Fairy": 2,
      "Fighting": 1,
      "Fire": 0.5,
      "Flying": 1,
      "Ghost": 1,
      "Grass": 1,
      "Ground": 1,
      "Ice": 2,
      "Normal": 1,
      "Poison": 1,
      "Psychic": 1,
      "Rock": 2,
      "Steel": 0.5,
      "Water": 0.5
    }
  },
  "water": {
    "name": "Water",
    "category": "Special",
    "effectiveness": {
      "???": 1,
      "Bug": 1,
      "Dark": 1,
      "Dragon": 0.5,
      "Electric": 1,
      "Fairy": 1,
      "Fighting": 1,
      "Fire": 2,
      "Flying": 1,
      "Ghost": 1,
      "Grass": 0.5,
      "Ground": 2,
      "Ice": 1,
      "Normal": 1,
      "Poison": 1,
      "Psychic": 1,
      "Rock": 2,
      "Steel": 1,
      "Water": 0.5
    }
  }
}